import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseTypeService from "../services/case-type-service";

export const caseTypeSearchSchema = z.object({
	status: z.string().optional(),
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	case_category_id: z.string().optional(),
});

export const caseTypesQueryOptions = (search?: z.infer<typeof caseTypeSearchSchema>, status?: string, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_type", search],
		queryFn: () => caseTypeService.list(transformSearch(search, ["search", "case_category_id", "status"])),
		...options,
	});
};

export const caseTypeQueryOptions = (caseTypeId: string) => {
	return queryOptions({
		queryKey: ["case_type", caseTypeId],
		queryFn: () => caseTypeService.findById(caseTypeId),
	});
};

export const useCaseTypeCreateMutation = (caseTypeId?: string) => {
	return useMutation({
		mutationKey: ["case_type", caseTypeId],
		mutationFn: caseTypeService.create,
		meta: {
			successMessage: "Case type created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case_type"] }),
	});
};

export const useCaseTypeMutation = (caseTypeId?: string) => {
	return useMutation({
		mutationKey: ["case_type", caseTypeId],
		mutationFn: caseTypeService.upsert,
		meta: {
			successMessage: "Case type updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case_type"] }),
	});
};
